module.exports = __webpack_public_path__ + "media/subepithelial tumor.0271859b.wav";